import { createSearchParams, Link, useNavigate } from 'react-router-dom';
import Modal from 'src/components/common/modal/modal';
import SearchInput from 'src/components/form/search-input/search-input';
import { GLOBAL_SEARCH } from 'src/constants/routes';
import css from './menu-modal.module.scss';
import { MenuCategory } from 'src/types';

export interface PopupProps<T> {
  onOpen: () => void;
  onClose: () => void;
  trigger: JSX.Element;
  dropdownItems?: T[];
}

export default function SearchPopup({ onOpen, onClose, trigger }: Readonly<PopupProps<MenuCategory>>) {
  const navigate = useNavigate();

  function handleSearch(value: string, close: () => void) {
    const trimedValue = value?.trim();
    if (trimedValue?.length > 0) {
      navigate({
        pathname: GLOBAL_SEARCH.path,
        search: createSearchParams({
          search: trimedValue
        }).toString()
      });
      close();
    }
  }

  return (
    <Modal onOpen={onOpen} onClose={onClose} trigger={trigger} lockScroll={false}>
      {(close: () => void) => (
        <div className={css.searchPopup}>
          <div className={css.container}>
            <SearchInput
              id='navbar-search'
              name='navbar-search'
              placeholder='Пошук'
              onSearch={(value: string) => handleSearch(value, close)}
              className={css.navbarSearch}
            />
            <div className={css.activeLinks}>
              Наприклад:
              <Link
                onClick={close}
                to={{
                  pathname: GLOBAL_SEARCH.path,
                  search: createSearchParams({
                    search: 'Військовослужбовцям'
                  }).toString()
                }}>
                Військовослужбовцям,
              </Link>
              <Link
                onClick={close}
                to={{
                  pathname: GLOBAL_SEARCH.path,
                  search: createSearchParams({
                    search: 'Родинам'
                  }).toString()
                }}>
                Родинам
              </Link>
              або
              <Link
                onClick={close}
                to={{
                  pathname: GLOBAL_SEARCH.path,
                  search: createSearchParams({
                    search: 'Реабілітація'
                  }).toString()
                }}>
                Реабілітація
              </Link>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
